@if (dataReady) {
  <div class="grid-container">
    <div class="grid-x">
      <div class="small-12 medium-12 large-12 bold">
        Formation Tops
      </div>
    </div>
    <div class="grid-x">
      <div class="cell large-12 medium-12 small-12">
        <ag-grid-angular class="data-grid " [rowData]="currentFormations" [gridOptions]="gridOptions" (gridReady)="onGridReady($event)" aria-label="Well Detail Formations"></ag-grid-angular>
      </div>
    </div>
  </div>
  <edit-formation-record [formationTypes]="allFormations" [methods]="allMethods" (recordEdited)="recordEdited($event)"></edit-formation-record>
}


